import { type FC, type RefObject, useMemo } from 'react';

import SpreadsheetV16 from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16.model';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTableV16';
import { DateTimeEditorV16 } from '@/components/UI/SpreadSheet/editors-v16/DateTimeEditorV16';
import Handsontable from 'handsontable-v16';
import type { CellChange } from 'handsontable-v16/common';

import { formatNumber } from '@/helpers.tsx';

import { createSummaryDisplayValueRenderer, createSummarySpreadsheetSettings } from './Summary.utils';
import type { SummaryTableProps } from './Summary.models';

const displayValueRendererV16 = createSummaryDisplayValueRenderer<Handsontable.Core, Handsontable.CellProperties>({
  callTextRenderer: (thisArg, instance, td, row, col, prop, value, cellProperties) => {
    Handsontable.renderers.TextRenderer.call(thisArg, instance, td, row, col, prop, value, cellProperties);
  },
  formatNumber,
});

const SpreadSheetV16: FC<SummaryTableProps> = ({ dosages, metadata, innerRef, onAfterChange }) => {
  const settings = useMemo<SpreadsheetV16Settings>(
    () =>
      createSummarySpreadsheetSettings({
        displayValueRenderer: displayValueRendererV16,
        dateTimeColumnType: DateTimeEditorV16.type,
      }) as SpreadsheetV16Settings,
    []
  );

  return (
    <SpreadsheetV16
      className={'mt3'}
      data={dosages as unknown as Array<Record<string, unknown>>}
      settings={settings}
      metadata={metadata}
      addCol={false}
      innerRef={innerRef as RefObject<HotTableRef>}
      maxRows={dosages.length}
      afterChange={(changes: CellChange[] | null) => onAfterChange(changes)}
    />
  );
};

export default SpreadSheetV16;
